import React from "react";

export default function Disclaimer() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12 text-white md:mt-14">
      <h1 className="text-3xl font-bold mb-6 text-lime-400">⚠️ Disclaimer</h1>

      <p className="mb-4">
        The information provided on <strong>iqcage.com</strong> is for general
        entertainment and educational purposes only. While we strive to ensure
        accuracy and reliability, we make no guarantees or representations of
        any kind regarding the completeness, accuracy, suitability, or
        availability of the content, games, or services offered.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">
        🕹️ Game Use Disclaimer
      </h2>
      <p className="mb-4">
        Our platform offers skill-based games that involve a certain level of
        decision-making and user interaction. Participation is entirely at your
        own risk. We are not liable for any losses, technical issues, or
        disputes that arise from gameplay.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">
        💰 Earnings & Rewards
      </h2>
      <p className="mb-4">
        Any earnings or rewards mentioned on this site are not guaranteed. They
        are based on player performance, skill level, and adherence to our
        platform rules. <strong>iqcage.com</strong> does not promote gambling or
        provide any guarantees of financial return.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">
        👤 User Responsibility
      </h2>
      <p className="mb-4">
        Users are solely responsible for ensuring that their use of this
        platform complies with local laws and regulations. By using our site,
        you confirm that you are at least 18 years of age or the legal age in
        your jurisdiction.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">🔗 External Links</h2>
      <p className="mb-4">
        <strong>iqcage.com</strong> may include links to third-party websites.
        We have no control over the content or practices of those sites and do
        not accept responsibility for any loss or damage that may occur from
        using them.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">📌 Final Note</h2>
      <p className="mb-4">
        By using this website, you agree to this disclaimer and our platform
        policies. If you do not agree with any part of this disclaimer, we
        advise that you discontinue using <strong>iqcage.com</strong>.
      </p>

      <p className="mt-8 text-sm text-slate-400">
        Last updated: {new Date().toLocaleDateString()}
      </p>
    </div>
  );
}
